/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable jsx-a11y/alt-text */
import { ethIcon } from '@mogul/shared';

import starIcon from '../../../common/images/staking/icon-star.svg';
import BSCLogo from '../../../common/svg/sidebar/header/bsc-logo.svg';
import { useWeb3State } from '../../../hooks';
import { CHAIN_ID_TO_TYPE_MAP, WEB3_CONFIG } from '../../../lib';
import { getCurrentChainId } from '../../../lib/smart-contract-utils';
import { Button, Colors } from '../../legacy/button/Button.component';
import styles from './WalletBalanceCard.module.css';

export interface ShowAssets {
  stars: boolean;
  eth: boolean;
}

const defaultShowAssets: ShowAssets = {
  stars: true,
  eth: true,
};

export interface WalletProps {
  transparent?: boolean;
  buttonReplacement?: JSX.Element;
  showAssets?: ShowAssets;
  getMoreStars?: () => void;
}

export const WalletBalanceCard: React.FC<WalletProps> = ({
  buttonReplacement,
  transparent = false,
  showAssets = defaultShowAssets,
  getMoreStars,
}: WalletProps) => {
  const { walletDetails } = useWeb3State();
  const isBSC = walletDetails.chain.id === WEB3_CONFIG.chains.bsc.id;

  return (
    <div
      className={
        (transparent ? 'bg-transparent ' : `${styles.walletContainerBg} `) +
        styles.walletContainer
      }
    >
      <div
        className={`py-5 lg:py-0 lg:flex lg:justify-between lg:my-3 w-full items-center`}
      >
        <div className={`flex flex-col`}>
          <div className={`ml-14 ${styles.walletHeader}`}>WALLET BALANCE</div>
          {showAssets.stars && (
            <div className={`pt-1 ${styles.walletInfoContainer}`}>
              <div className={styles.starsImageContainer}>
                <img src={starIcon} />
              </div>
              <div className={`flex items-center ${styles.walletDiv}`}>
                <div className={styles.walletBody}>{`${parseFloat(
                  walletDetails.balance.stars.formatted,
                ).toLocaleString('en-us', {
                  maximumFractionDigits: 2,
                  useGrouping: true,
                })} STARS AVAILABLE`}</div>
              </div>
            </div>
          )}
          {showAssets.eth && !isBSC && (
            <div className={`pt-1 ${styles.walletInfoContainer}`}>
              <div className={styles.starsImageContainer}>
                <img src={ethIcon} />
              </div>
              <div className={`flex items-center ${styles.walletDiv}`}>
                <div className={styles.walletBody}>{`${parseFloat(
                  walletDetails.balance.native.formatted,
                ).toLocaleString('en-us', {
                  maximumFractionDigits: 2,
                  useGrouping: true,
                })} ${
                  CHAIN_ID_TO_TYPE_MAP[getCurrentChainId()]
                } AVAILABLE`}</div>
              </div>
            </div>
          )}
          {showAssets.eth && isBSC && (
            <div className={`pt-1 ${styles.walletInfoContainer}`}>
              <div className={styles.starsImageContainer}>
                <img src={BSCLogo} />
              </div>
              <div className={`flex items-center ${styles.walletDiv}`}>
                <div className={styles.walletBody}>{`${parseFloat(
                  walletDetails.balance.native.formatted,
                ).toLocaleString('en-us', {
                  maximumFractionDigits: 2,
                  useGrouping: true,
                })} BNB AVAILABLE`}</div>
              </div>
            </div>
          )}
        </div>
        <div className="ml-4 lg:ml-0">
          {buttonReplacement ?? (
            <Button color={Colors.COLOR_SCHEME_4} onClick={getMoreStars}>
              GET MORE
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
